import { useCallback, useState } from 'react';
import { OrderRowData } from 'types';

const useTableFilter = (tableData: any, filterKey: string) => {
  const [filterBy, setFilterBy] = useState<string[]>([]);
  const [filteredData, setFilteredData] = useState<OrderRowData[]>([]);

  const filterHandler = useCallback(
    (event?: React.ChangeEvent<HTMLInputElement>) => {
      if (!event) {
        setFilterBy([]);
        setFilteredData([]);
        return;
      }
      if (event.target.checked) {
        setFilterBy(prev => [...prev, event.target.value]);
      } else {
        const filteredStatuses = filterBy.filter(
          status => status !== event.target.value
        );
        setFilterBy(filteredStatuses);
      }
    },
    [filterBy]
  );

  const applyFilter = useCallback(() => {
    const filtered = tableData.filter((data: any) =>
      filterBy.includes(data[filterKey] ?? '')
    );
    setFilteredData(filtered);
  }, [filterBy, filterKey, tableData]);

  return { filteredData, setFilteredData, filterHandler, applyFilter };
};

export default useTableFilter;
